import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { ElForm, ElFormItem, ElInput } from 'element-plus'
import { ref, defineProps, onMounted, defineEmits, computed } from 'vue'
import { FlowFormModel } from '../types'
const __default__ = {
  name: 'SnakerFlowProcess'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

// 注意:ref不能与model一样，相同的话表单双向绑定将会失效
const formRef = ref(null)
// const form = reactive<FlowFormModel>({} as FlowFormModel)
// 定义属性
const props = __props
const emits = __emit
const form = computed<FlowFormModel>({
  get: () => props.modelValue,
  set: (val) => emits('update:modelValue', Object.assign(props.modelValue, val))
})
// watch(() => form, (n, o) => {
//   emits('update:modelValue', Object.assign(props.modelValue, form))
// }, { deep: true })

onMounted(() => {
  Object.assign(form, props.modelValue)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElForm), {
    ref_key: "formRef",
    ref: formRef,
    model: form.value,
    "label-width": "130px",
    size: "default"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ElFormItem), { label: "流程定义名称" }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElInput), {
            modelValue: form.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_unref(ElFormItem), { label: "流程定义显示名称" }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElInput), {
            modelValue: form.value.displayName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.displayName) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_unref(ElFormItem), { label: "期望完成时间" }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElInput), {
            modelValue: form.value.expireTime,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.expireTime) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_unref(ElFormItem), { label: "实例启动Url" }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElInput), {
            modelValue: form.value.instanceUrl,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.instanceUrl) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_unref(ElFormItem), { label: "实例编号生成类" }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElInput), {
            modelValue: form.value.instanceNoClass,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.instanceNoClass) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})